import { ValidationError } from "sequelize"
import {
    MtStudyTeamMember,
    MtStudyTeamMemberCreate,
    MtStudyTeamMemberSave,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import {
    LangType,
    StudyTeamMemberList,
    StudyTeamMemberValidation,
    StudyTeamMemberFilters,
} from "client/store"

export const LoadAllStudyTeamMembers = (studyId: number) => (
    GET(`/mtStudyTeamMember/studyId/${studyId}`)
    .then((teamMembers: MtStudyTeamMember[]) => {
        const teamMemberList: StudyTeamMemberList = {}
        teamMembers.forEach((teamMember) => {
            teamMemberList[teamMember.id] = teamMember
        })
        return teamMemberList
    })
)

export const LoadStudyTeamMemberById = (teamMemberId: number, studyId: number) => (
    GET(`/mtStudyTeamMember/id/${teamMemberId}/studyId/${studyId}`)
    .then((teamMember: MtStudyTeamMember) => teamMember)
)

export const SaveStudyTeamMember = (
    id: number,
    teamMember: MtStudyTeamMemberCreate,
    lang: LangType,
) => {
    const data: MtStudyTeamMemberSave = {
        id,
        teamMember,
    }
    return POST(
        "/mtStudyTeamMember/save",
        JSON.stringify(data),
    ).then((res) => {
        const newTeamMember = res as MtStudyTeamMember
        const error = res as ValidationError

        return {
            newTeamMemberId: newTeamMember.id || null,
            validation: <StudyTeamMemberValidation>validate(error, lang),
        }
    })
}

export const DeleteStudyTeamMember = (teamMemberId: number, studyId: number) => (
    DELETE(`/mtStudyTeamMember/delete/${teamMemberId}/${studyId}`)
    .then((removedRows: number) => removedRows)
)

export const SortStudyTeamMembers = (
    teamMembers: MtStudyTeamMember[],
    sortColumn: keyof MtStudyTeamMember,
    sortOrder: OrderType,
    filters: StudyTeamMemberFilters,
): number[] => {
    const teamMembersFiltered = teamMembers.filter((teamMember) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, teamMember)
        return showRow
    })

    const teamMemberIds: number[] = []
    teamMembersFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))
    teamMembersFiltered.forEach((teamMember) => teamMemberIds.push(teamMember.id))

    return teamMemberIds
}
